import { createContext } from "react";

const LocaleContext = createContext({
  locale: "",
  setLocale: () => null,
});

export default LocaleContext;
